import React from 'react'
import cx from 'classnames'
import styles from './style.module.sass'

export default ({ children, classes, tag = `p` }) => {
  const ContentTag = tag

  return <ContentTag className={cx(styles.block, classes)}>{children}</ContentTag>
}
